// ===============================================================
// Zendesk
// ===============================================================
export function Zendesk() {
  const setZendesk = () => {
    window.removeEventListener('mousemove', setZendesk);
    window.removeEventListener('scroll', setZendesk);

    console.log('Zendesk Widget detected!');

    // Adiciona script do componente
    let newScript = document.createElement('script');
    newScript.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=018344dd-c5b7-489e-b161-c69cb4c07cdd');
    newScript.setAttribute('id', 'ze-snippet');
    document.body.appendChild(newScript);
  }
  window.addEventListener('mousemove', setZendesk);
  window.addEventListener('scroll', setZendesk);
};

// ===============================================================
// RDSTATION
// ===============================================================
export function RDStation() {
  const setRDStation = () => {
    window.removeEventListener('mousemove', setRDStation);
    window.removeEventListener('scroll', setRDStation);

    console.log('setRDStation detected!');

    // Adiciona script do componente
    let newScript = document.createElement('script');
    newScript.setAttribute('src', 'https://d335luupugsy2.cloudfront.net/js/loader-scripts/3f0dfdfb-dacf-4041-a011-59920f23b0a0-loader.js');
    document.body.appendChild(newScript);
  }
  window.addEventListener('mousemove', setRDStation);
  window.addEventListener('scroll', setRDStation);
};

// ===============================================================
// RDSTATION
// ===============================================================
export function widgetWhatsapp() {
  const setWidgetWhatsapp = () => {
    window.removeEventListener('mousemove', setWidgetWhatsapp);
    window.removeEventListener('scroll', setWidgetWhatsapp);

    console.log('setWidgetWhatsapp detected!');

    // Adiciona script do componente
    let newIframe = document.createElement('iframe');
    newIframe.setAttribute('class', 'widget-whatsapp');
    newIframe.setAttribute('src', 'https://cdn.smooch.io/message-us/index.html?channel=whatsapp&color=teal&size=standard&radius=20px&label=&number=5521972556468');
    newIframe.setAttribute('width', '90');
    newIframe.setAttribute('height', '50');
    document.body.appendChild(newIframe);
  }
  window.addEventListener('mousemove', setWidgetWhatsapp);
  window.addEventListener('scroll', setWidgetWhatsapp);
};

